/*
 * Copyright © 2026, CodeVision. All rights reserved.
 * 
 * This file was generated by Codevision's stub generator
 */ 

import { VehicleType } from './vehicleType';
import { WorkState } from './workState';
import { ServiceType } from './serviceType';

export class WorkQueueDisplayModel {

    workStationId: number;
    plateNumber: string;
    vehicleType: VehicleType;
    note: string;
    workState: WorkState;
    vehicleTypeDefinitionId: number;
    serviceType: ServiceType;

    constructor() {

    }


}
